export default "__VITE_ASSET__5c50452a__"